<pre [ngClass]="isThemeHacker ? 'is_dark' : 'is_light'" [innerHTML]="htmlString"></pre>
